import { createSlice } from "@reduxjs/toolkit";
import { checkEmailExist } from "./thunk";

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  investRegistrationError: null,
  investLoading: false,
  investUser: null,
  investSuccess: false,
  error: false,
  // Get Summary Cards
  checkEmailExistData: [],
  checkEmailExistError: {},
};

const registerSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    registerUserSuccessful(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.success = true;
      state.registrationError = null;
    },
    registerUserFailed(state, action) {
      state.user = null;
      state.loading = false;
      state.registrationError = action.payload;
      state.error = true;
    },
    registerInvestUserSuccessful(state, action) {
      state.investUser = action.payload;
      state.investLoading = false;
      state.investSuccess = true;
      state.investRegistrationError = null;
    },
    registerInvestUserFailed(state, action) {
      state.investUser = null;
      state.investLoading = false;
      state.investRegistrationError = action.payload;
      state.error = true;
    },
    resetRegisterFlagChange(state) {
      state.success = false;
      state.error = false;
    },
    apiErrorChange(state: any, action) {
      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
    },
  },
  extraReducers: (builder) => {
    // Check Email Exist
    builder.addCase(checkEmailExist.fulfilled, (state: any, action: any) => {
      state.checkEmailExistData = action.payload;
    });
    builder.addCase(checkEmailExist.rejected, (state: any, action: any) => {
      state.checkEmailExistError = action.error.message;
    });
  },
});

export const {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
  registerInvestUserSuccessful,
  registerInvestUserFailed,
} = registerSlice.actions;

export default registerSlice.reducer;
